import React, { Component } from "react";
import { Outlet } from 'react-router-dom';
import { withRouter } from "../common/with-router";
import { Link } from "react-router-dom";
import http from "../http-common";
import ReportService from "../services/report.service"
import NavItem from "../nav-item";

class ReportsSessions extends Component {
  constructor(props) {
    super(props);
    this.handleError = this.handleError.bind(this);
    this.onChangeSessionDate = this.onChangeSessionDate.bind(this);
    var token = window.sessionStorage.getItem("token");
    this.state = {
      baseURL: http.defaults.baseURL + "/reports",
      token: token,
      sessionDates: null,
      sessionDate: null,
    };
    ReportService.listSessionDates()
    .then(resp => {
      const sessionDates = resp.data.sessionDates;
      const sessionDate = this.findUpcomingSessionDate(sessionDates);
      this.setState({sessionDates: sessionDates.reverse(), sessionDate: sessionDate});
    })
    .catch(this.handleError);
  }

  componentDidUpdate() {
    if (this.props.router.location.pathname === "/reports/sessions") {
      this.props.router.navigate("/reports/sessions/signups", {replace: true});
    }
  }

  handleError(e) {
    if (e.response?.status === 403) {
      this.props.router.navigate("/login");
    }
  }

  findUpcomingSessionDate(sessionDates) {
    if (sessionDates.length === 0) {
      return null;
    }
    const now = new Date().getTime();
    for (const sessionDate of sessionDates) {
      if (new Date(sessionDate.startDate).getTime() > now) {
        return sessionDate.startDate;
      }
    }
    return sessionDates[sessionDates.length - 1].startDate;
  }

  onChangeSessionDate(e) {
    const sessionDate = e.target.value;
    this.setState({sessionDate: sessionDate});
  }

  render() {
    return (
      <div>
        <select className="form-select mb-3" value={this.state.sessionDate ? this.state.sessionDate : ""} onChange={this.onChangeSessionDate}>
          {!this.state.sessionDates && (<option>Loading...</option>)}
          {this.state.sessionDates?.length === 0 && (<option>No sessions yet</option>)}
          {this.state.sessionDates?.map(sessionDate => (
            <option key={sessionDate.startDate} value={sessionDate.startDate}>{sessionDate.startDate}</option>
          ))}
        </select>
        <ul className="nav nav-tabs mb-3">
          <NavItem to="signups" text="Sign-ups" />
          <NavItem to="attendance" text="Attendance" />
        </ul>
        {this.state.sessionDate && (<Outlet context={this.state.sessionDate} />)}
        <div>Complete member list <Link to={this.state.baseURL + "/members?token=" + this.state.token} target="_blank">Download</Link></div>
      </div>
    );
  }
}

export default withRouter(ReportsSessions);